import React from "react";
import { isMarkActive, toggleMark } from "../../utils/slateUtils";
import KoIcon from '@kwapio/icons';
import KoButton from "packages/button";


export const MarkButton = ({ color, editor, format, icon, disabled }) => {
  const active = isMarkActive(editor, format);



  const iconMap = {
    bold: <KoIcon width={20} height={20} color={color} name="BoldOutlined" />,
    italic: <KoIcon  width={20} height={20} color={color} name="ItalicOutlined" />,
    underline:<KoIcon  width={20} height={20} color={color} name="UnderlineOutlined" />,
    strikethrough: <KoIcon width={20} height={20}  color={color} name="StrikethroughOutlined" />
  };

  return (
    <KoButton
      type="text"
      iconBtn
      icon={iconMap[icon]}
      color={color}
      disabled={disabled}
      active={active}
      onClick={(e) => { e.preventDefault(); toggleMark(editor, format); }}
    />
    
  );
};
